import Modal from "react-modal";
import { AlertCircle, X } from "lucide-react";

export const fieldClass = "crm-field h-10 w-full min-w-0 rounded-xl border border-[#d6e5eb] bg-white px-3 text-sm text-[#17384e] outline-none focus:border-[#49add8] focus:ring-2 focus:ring-[#dff3fb] disabled:opacity-50";
// AUTO-CRM-32: Stage buttons (src/stage/stage.css).
export const buttonClass = "ws-btn ws-btn--quiet ws-btn--sm";
export const primaryClass = "ws-btn ws-btn--primary ws-btn--sm";

export function DocumentError({ message }) {
  return message ? <div role="alert" className="flex items-start gap-2 rounded-xl border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800"><AlertCircle className="mt-0.5 h-4 w-4 shrink-0" /><span>{message}</span></div> : null;
}

export function DocumentDialog({ title, onClose, busy, children, wide = false, side = false }) {
  return <Modal isOpen onRequestClose={busy ? undefined : onClose} shouldCloseOnOverlayClick={!busy} shouldCloseOnEsc={!busy}
    ariaHideApp={Boolean(document.getElementById("root"))} appElement={document.getElementById("root") || undefined}
    contentLabel={title} className={side ? "crm-document-drawer" : `crm-dialog m-auto max-h-[90dvh] w-full ${wide ? "max-w-3xl" : "max-w-xl"} overflow-y-auto bg-white p-5 outline-none sm:p-6`}
    overlayClassName={side ? "crm-document-drawer-overlay ws-overlay" : "ws-overlay fixed inset-0 z-[100] flex bg-[rgba(16,47,69,0.32)] p-4 backdrop-blur-[3px]"}>
    <div onKeyDown={(event) => { if (event.key === "Escape") { event.stopPropagation(); if (!busy) onClose(); } }}>
      <div className="mb-5 flex items-center justify-between gap-3"><h2 className="ws-h2">{title}</h2><button type="button" aria-label="Close dialog" disabled={busy} onClick={onClose} className="crm-icon-btn crm-icon-btn--sm"><X size={15} /></button></div>
      {children}
    </div>
  </Modal>;
}
